import styled from 'styled-components';
import { StyledVariantFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { StyledTextAreaWrapper } from 'ui/inputs/textArea/TextArea.styles';

export const StyledVariantTextAreaFormField = styled(StyledVariantFormField)`
  ${StyledTextAreaWrapper} {
    flex-direction: row;
  }
`;

export const StyledCopyAssistWrapper = styled.div`
  position: relative;
`;
